import "./customModal.scss";

import type { ReactNode } from "react";
import { useCallback, useState } from "react";
import type { ModalProps } from "react-bootstrap";
import { Modal } from "react-bootstrap";

import { ContractIcon, ExpandIcon } from "../icons";
import { ErrorNotification } from "./ErrorNotifacation";

export interface IProps {
  show: boolean;
  handleClose: () => void;
  footer?: ReactNode;
  children: ReactNode;
  title?: string;
  closeButton?: boolean;
  className?: string;
  bodyClassName?: string;
  errorMessage?: string | null;
  resizable?: boolean;
  size?: "sm" | "lg" | "xl";
}

const CustomModal: React.FC<IProps> = ({
  show,
  handleClose,
  footer,
  children,
  title,
  closeButton = true,
  className = "",
  bodyClassName = "",
  errorMessage,
  resizable = false,
  size = "md",
}) => {
  const [largeModal, setLargeModal] = useState(false);
  const toggleSize = useCallback(
    () => setLargeModal(!largeModal),
    [largeModal],
  );
  const collapseModal = useCallback(() => setLargeModal(false), []);
  return (
    <Modal
      className={`custom-modal ${className} ${largeModal ? "expanded" : ""}`}
      show={show}
      onHide={handleClose}
      onExited={collapseModal}
      size={size as ModalProps["size"]}
    >
      {title && (
        <Modal.Header
          closeButton={closeButton}
          className={`${resizable ? "justify-content-center" : ""}`}
        >
          <Modal.Title className="fs-2">{title}</Modal.Title>
          {resizable && (
            <button
              className="btn-expand ms-auto"
              onClick={toggleSize}
              data-testid="modal-resize-button"
            >
              {largeModal ? <ContractIcon /> : <ExpandIcon />}
            </button>
          )}
        </Modal.Header>
      )}

      <Modal.Body className={`p-9 ${bodyClassName}`}>
        {errorMessage && <ErrorNotification message={errorMessage} />}
        {children}
      </Modal.Body>
      {footer && <Modal.Footer className="px-9 py-8">{footer}</Modal.Footer>}
    </Modal>
  );
};

export { CustomModal };
